//import { Etat } from "../Constants/Enum";
import { get, post } from "./network_utils";

export class ConsumeApi {
    base_url = "https://app.shouz.network/api/v1";
    getAllTypeForPackageEventFromWebSite_url = this.base_url + "/event/getAllTypeForWebSite";
    getAllInfoTikTok_url = this.base_url + "/client/getInfoTikTok";
    getInfoForShouzWebsite_url = this.base_url + "/client/getInfoForShouzWebsite";
    getExclusifInfoTikTok_url = this.base_url + "/client/getExclusifInfoTikTok";
    createSaliorTikTokOrUpdateVoted_url = this.base_url + "/client/createSaliorTikTokOrUpdateVoted";
    createBlanckUser_url = this.base_url + "/client/createEmptyClient";

    getAllVote_url = this.base_url + "/vote-event/getVoteEvent";

    constructor() {}

    async testPost(numero, password) {
        const body = {
            numero,
            password
        };
        return await post(this.getAllTypeForPackageEventFromWebSite_url, body);
    }

    async voted(idCategorie, actorId, idFacebook, email) {
        const body = {
            idCategorie,
            actorId,
            idFacebook,
            email
        };
        return await post(this.createSaliorTikTokOrUpdateVoted_url, body);
    }

    async createBlanckUser() {
        const body = {};
        const result = await post(this.createBlanckUser_url, body);
        if(result['etat'] === 'found') {
            localStorage.setItem('identShouz', result.result._id.toString());
            localStorage.setItem('recoveryShouz', result.result.recovery.trim());
        }
        return result['etat'] === 'found';

    }

    async getAllVote() {
        const ident = localStorage.getItem("identShouz");
        return await get(`${this.getAllVote_url}/${ident}`);
    }

    async getAllTypeForPackageEventFromWebSite() {
        return await get(`${this.getAllTypeForPackageEventFromWebSite_url}/XOF`);
    }

    async getAllInfoTikTokFromWebSite() {
        return await get(this.getAllInfoTikTok_url);
    }

    async getInfoForShouzWebsite() {
        return await get(this.getInfoForShouzWebsite_url);
    }

    async getInfoTikTokFromExclusive(name) {
        return await get(`${this.getExclusifInfoTikTok_url}/${name}`);
    }
}